import React from 'react';
import { useParams } from 'react-router-dom';
import FormBuilder from '../components/FormBuilder';

function FormBuilderPage() {
  const { id } = useParams();
  
  return <FormBuilder formId={id} />;
}

export default FormBuilderPage;
